import { AttractionCategoryEnum } from '@escapenavigator/types/dist/city-attraction/enum/attraction-category.enum';
import { AttractionFameEnum } from '@escapenavigator/types/dist/city-attraction/enum/attraction-fame.enum';
import { AttractionIndoorOutdoorEnum } from '@escapenavigator/types/dist/city-attraction/enum/attraction-indoor-outdoor.enum';
import { AttractionRouteRoleEnum } from '@escapenavigator/types/dist/city-attraction/enum/attraction-route-role.enum';

const CATEGORY_LABELS: Record<AttractionCategoryEnum, string> = {
    [AttractionCategoryEnum.MUSEUM]: 'Museum',
    [AttractionCategoryEnum.TEMPLE_CHURCH]: 'Temple / church',
    [AttractionCategoryEnum.ARCHITECTURE_LANDMARK]: 'Architecture / landmark',
    [AttractionCategoryEnum.PALACE_FORTRESS]: 'Palace / fortress',
    [AttractionCategoryEnum.ARCHAEOLOGICAL_SITE]: 'Archaeological site',
    [AttractionCategoryEnum.PARK_GARDEN]: 'Park / garden',
    [AttractionCategoryEnum.VIEWPOINT]: 'Viewpoint',
    [AttractionCategoryEnum.SQUARE]: 'Square',
    [AttractionCategoryEnum.STREET_DISTRICT]: 'Street / district',
    [AttractionCategoryEnum.BRIDGE]: 'Bridge',
    [AttractionCategoryEnum.MARKET]: 'Market',
    [AttractionCategoryEnum.CEMETERY_NECROPOLIS]: 'Cemetery',
    [AttractionCategoryEnum.THEATER_CULTURAL_VENUE]: 'Theater / cultural venue',
    [AttractionCategoryEnum.MONUMENT_MEMORIAL]: 'Monument / memorial',
    [AttractionCategoryEnum.CANAL_WATERFRONT]: 'Canal / waterfront',
    [AttractionCategoryEnum.TRANSPORT_LANDMARK]: 'Transport landmark',
    [AttractionCategoryEnum.STADIUM]: 'Stadium',
    [AttractionCategoryEnum.ZOO_AQUARIUM]: 'Zoo / aquarium',
    [AttractionCategoryEnum.UNUSUAL_PLACE]: 'Unusual place',
};

const FAME_LABELS: Record<AttractionFameEnum, string> = {
    [AttractionFameEnum.ICON]: 'Icon',
    [AttractionFameEnum.WELL_KNOWN]: 'Well known',
    [AttractionFameEnum.OFFBEAT]: 'Offbeat',
    [AttractionFameEnum.HIDDEN_GEM]: 'Hidden gem',
};

const ROUTE_ROLE_LABELS: Record<AttractionRouteRoleEnum, string> = {
    [AttractionRouteRoleEnum.ANCHOR]: 'Anchor',
    [AttractionRouteRoleEnum.PRIMARY]: 'Primary',
    [AttractionRouteRoleEnum.CONNECTOR]: 'Connector',
    [AttractionRouteRoleEnum.OPTIONAL]: 'Optional',
    [AttractionRouteRoleEnum.DETOUR]: 'Detour',
};

const INDOOR_OUTDOOR_LABELS: Record<AttractionIndoorOutdoorEnum, string> = {
    [AttractionIndoorOutdoorEnum.INDOOR]: 'Indoor',
    [AttractionIndoorOutdoorEnum.OUTDOOR]: 'Outdoor',
    [AttractionIndoorOutdoorEnum.MIXED]: 'Mixed',
};

export const categoryLabel = (value: AttractionCategoryEnum) => CATEGORY_LABELS[value] ?? value;

export const fameLabel = (value: AttractionFameEnum) => FAME_LABELS[value] ?? value;

export const routeRoleLabel = (value: AttractionRouteRoleEnum) => ROUTE_ROLE_LABELS[value] ?? value;

export const indoorOutdoorLabel = (value: AttractionIndoorOutdoorEnum) =>
    INDOOR_OUTDOOR_LABELS[value] ?? value;

export const categoryOptions = Object.values(AttractionCategoryEnum).map((value) => ({
    value,
    label: categoryLabel(value),
}));

export const fameOptions = Object.values(AttractionFameEnum).map((value) => ({
    value,
    label: fameLabel(value),
}));

export const routeRoleOptions = Object.values(AttractionRouteRoleEnum).map((value) => ({
    value,
    label: routeRoleLabel(value),
}));

export const indoorOutdoorOptions = Object.values(AttractionIndoorOutdoorEnum).map((value) => ({
    value,
    label: indoorOutdoorLabel(value),
}));
